var __rspack_ns_object = JSON.parse('{"Zoom":"تكبير/تصغير"}')